import { createSlice } from "@reduxjs/toolkit";
import { AuthState } from "../types/types";
import { fetchLogin, logout, fetchRegisterOrganization } from "./auth-thunk";
import { ErrorType } from "@/shared/types";

const initialState: AuthState = {
    isAuth: false,
    isLoading: false,
    error: null
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
        .addCase(fetchLogin.pending, (state) => {
            state.error = null
            state.isAuth = false
            state.isLoading = true
        })
        .addCase(fetchLogin.fulfilled, (state) => {
            state.error = null
            state.isAuth = true
            state.isLoading = false
        })
        .addCase(fetchLogin.rejected, (state, action) => {
            state.error = action.payload as ErrorType ?? null
            state.isAuth = false
            state.isLoading = false
        })
        .addCase(logout.fulfilled, (state) => {
            state.isAuth = false
        })
        .addCase(fetchRegisterOrganization.pending, (state) => {
            state.error = null
            state.isAuth = false
            state.isLoading = true
        })
        .addCase(fetchRegisterOrganization.fulfilled, (state) => {
            state.error = null
            state.isAuth = true
            state.isLoading = false
        })
        .addCase(fetchRegisterOrganization.rejected, (state, action) => {
            state.error = action.payload as ErrorType ?? null
            state.isAuth = false
            state.isLoading = false
        })
    },
})

export default authSlice.reducer